import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-service-menu',
  templateUrl: './service-menu.component.html',
  styleUrls: ['./service-menu.component.scss']
})
export class ServiceMenuComponent implements OnInit {

  seletedService;
  private _servicesList :any;
  get servicesList() {
    return this._servicesList;
  }
  @Input()
  set servicesList(servicesList) {
    this._servicesList = servicesList;
    // console.log(this._servicesList);
    // console.log(this._servicesList);
  }


  constructor() { }

  ngOnInit() {
  }

}
